<template>
  <tr class="document">
    <td class="document-number">
      <b-input v-model="document.number" @change="handleUpdate"></b-input>
    </td>
    <td class="document-name">
      <b-input v-model="document.name" @change="handleUpdate"></b-input>
      <span class="link" @click="handleloadFile" v-if="!document.document">
        Загрузить документ
      </span>
      <span v-else>
        <span class="link">{{document.document | path }}</span>
        <span class="delete-document" @click="deleteDocumentFile(document.id)">X</span>
      </span>
      <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
    </td>
    <td class="date-pickers">
      <el-date-picker
        type="date"
        :editable="false"
        v-model="startDate"
        @change="dateChanged"
        >
      </el-date-picker>
      —
      <el-date-picker
        type="date"
        :editable="false"
        v-model="endDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td>
      <el-date-picker
        type="date"
        :editable="false"
        v-model="disclosureDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="delete-cell">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteDocument(document.id)"/>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DocumentItem',
  data () {
    return {
      updateTimer: null,
      startDate: '',
      endDate: '',
      disclosureDate: ''
    }
  },
  props: {
    document: {
      required: true
    }
  },
  created () {
    this.startDate = this.document.startDate
    this.endDate = this.document.endDate
    this.disclosureDate = this.document.disclosureDate
  },
  filters: {
    path (path) {
      return path.split('/').pop()
    }
  },
  methods: {
    ...mapActions(['deleteDocument', 'deleteDocumentFile', 'updateDocument']),
    handleUpdate () {
      this.updateDocument(this.document)
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('document', file)
      this.document.newFile = formData
      this.document.document = file.name
      this.updateDocument(this.document)
      this.$forceUpdate()
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    },
    deleteDocumentFile () {
      delete this.document.newFile
      this.document.document = ''
      this.updateDocument(this.document)
      this.$forceUpdate()
    },
    dateChanged () {
      this.document.startDate = this.startDate
      this.document.endDate = this.endDate
      this.document.disclosureDate = this.disclosureDate
      this.handleUpdate()
    }
  }
}
</script>
<style scoped>
.document .delete-icon {
  position: initial;
  width: 27px;
  margin-top: 5px;
}
.document td {
  padding: 20px 10px;
}
.documents tr {
  border-bottom: 1px solid lightgray;
  border-top: 1px solid lightgray;
}
.date-pickers {
  width: 430px;
}
.delete-cell {
  width: 47px;
  min-width: 47px;
}
.document .document-number {
  width: 110px;
  padding-left: 0;
}
.document-name {
  padding-left: 25px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.delete-document {
  color: gray;
  font-size: 20px;
  vertical-align: middle;
  margin: 0 0 0 7px;
  font-family: monospace;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// DocumentItem.vue?3e41de73